import React from 'react';
import { HealthDeclarationForm } from '@/components/HealthDeclarationForm/HealthDeclarationForm';

export default function HealthDeclaration() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#FFF8F0] to-white py-12 px-4">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <h1
            className="text-4xl md:text-5xl font-bold text-[#1B4332] mb-4"
            style={{ fontFamily: 'var(--font-heading)' }}
          >
            הצהרת בריאות
          </h1>
          <p className="text-lg text-[#6B7280] text-right">
            אנא מלא את הטופס בעדינות ובדיוק. כל המידע יישמר בסודיות מלאה.
          </p>
        </div>

        {/* Form */}
        <HealthDeclarationForm
          trainerEmail="sharon@sharon.fitness"
          onSuccess={() => {
            // Optional: Show success message or redirect
            console.log('Form submitted successfully');
          }}
        />

        {/* Footer Note */}
        <div className="mt-12 text-center">
          <p className="text-sm text-[#6B7280] text-right">
            אם יש לך שאלות, אנא צור קשר עם שרון בטלפון או בדוא"ל.
          </p>
        </div>
      </div>
    </div>
  );
}
